__webpack_require__.p = "/mi-assets/mi-static/mi-account-renderer/web-rel-26.10.2-101526/_next/";